export default __webpack_public_path__ + "static/media/Presenciales.999c68dd.svg";